/**
 * HEMS Capacitor 하드웨어 Back 처리
 * - 리스너 등록 시 Capacitor 기본 WebView.goBack() 이 비활성화되므로 여기서 전부 처리한다.
 * - PC / 일반 브라우저: no-op
 */

import mobileBridge from "./mobileBridge.js";

/** @type {Array<() => boolean>} 시트가 열려 있으면 true 반환해 Back 소비 */
let overlayHandlers = [];

/**
 * 오버레이(월 선택 시트 등) Back 핸들러 등록.
 * @param {() => boolean} handler true면 Back 이벤트 소비
 * @returns {() => void} unregister
 */
export function registerHemsBackOverlay(handler) {
    if (typeof handler !== "function") {
        return () => {};
    }
    overlayHandlers.push(handler);
    return () => {
        overlayHandlers = overlayHandlers.filter((h) => h !== handler);
    };
}

function consumeOverlay() {
    for (let i = overlayHandlers.length - 1; i >= 0; i--) {
        try {
            if (overlayHandlers[i]()) return true;
        } catch (e) {
            console.warn("[hemsBackButton] overlay handler failed", e);
        }
    }
    return false;
}

function isHemsPath(path) {
    const p = String(path || "");
    return p === "/hems/login" || p === "/hems/resident" || p.startsWith("/hems/");
}

/**
 * @param {import('vue-router').default} router
 */
export async function initHemsBackButton(router) {
    if (!mobileBridge.isCapacitor() || !router) {
        return;
    }
    try {
        const { App } = await import("@capacitor/app");
        await App.addListener("backButton", async ({ canGoBack }) => {
            if (consumeOverlay()) {
                return;
            }

            const path = router.currentRoute?.path || "";

            // HEMS: 로그인으로의 goBack 금지. 루트에서는 앱 종료.
            if (isHemsPath(path)) {
                await App.exitApp();
                return;
            }

            if (canGoBack) {
                window.history.back();
                return;
            }
            await App.exitApp();
        });
    } catch (e) {
        console.warn("[hemsBackButton] init failed", e);
    }
}
